
import { computed, defineComponent, useAttrs } from 'vue'
import { normalizeSvgForTheme } from './svg-theme'

const svgModules = require.context('!raw-loader!../..', true, /\.svg$/)

function getSvgRaw (name: string): string | undefined {
  try {
    const mod = svgModules(`./${name}.svg`)
    return typeof mod === 'string' ? mod : (mod && mod.default)
  } catch {
    return undefined
  }
}

function formatDimension (value: number | string): string {
  return typeof value === 'number' ? `${value}px` : String(value)
}

export default defineComponent({
  name: 'CmSvgIcon',
  inheritAttrs: false,
  props: {
    /** SVG icon key (path under src/, minus .svg extension) */
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: undefined,
    },
    width: {
      type: [Number, String],
      default: undefined,
    },
    height: {
      type: [Number, String],
      default: undefined,
    },
    /** 单色图标：#111 等也使用 currentColor，颜色继承父级（如按钮文字色） */
    monochrome: {
      type: Boolean,
      default: false,
    },
    /** 显式指定图标色（用于主色按钮上的白色图标等） */
    color: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    ariaLabel: {
      type: String,
      default: undefined,
    },
    ariaHidden: {
      type: Boolean,
      default: true,
    },
  },
  setup (props) {
    const attrs = useAttrs()

    const svgHtml = computed(() => {
      const raw = getSvgRaw(props.name)
      if (!raw) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn(`[CmSvgIcon] missing icon: ${props.name}`)
        }
        return ''
      }
      return normalizeSvgForTheme(raw, { monochrome: props.monochrome })
    })

    const mergedStyle = computed(() => {
      const w = props.width ?? props.size
      const h = props.height ?? props.size
      const style: Record<string, string> = {}

      // 仅在有显式 props 时写 inline 尺寸，其余交给 CSS class（如 .locale-icon { 24px }）
      if (w != null) style.width = formatDimension(w)
      if (h != null) style.height = formatDimension(h)

      if (props.color) style.color = props.color

      const externalStyle = attrs.style
      if (externalStyle && typeof externalStyle === 'object' && !Array.isArray(externalStyle)) {
        Object.assign(style, externalStyle)
      }

      return style
    })

    return {
      svgHtml,
      mergedStyle,
    }
  },
})
